import { render } from "./purchaseList.vue?vue&type=template&id=532ebb80&scoped=true&ts=true"
import script from "./purchaseList.vue?vue&type=script&lang=ts"
export * from "./purchaseList.vue?vue&type=script&lang=ts"

import "./purchaseList.vue?vue&type=style&index=0&id=532ebb80&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532ebb80"]])

export default __exports__